import { Customer } from "../../customer";
import { provideReact } from "../../react/index.js";
import { FinderProfile } from "../FinderProfile";
import { FinderProfileRequest } from "../FinderProfileRequest";

export class LeadFyndr {
  public static customerIdHasAccess = provideReact(
    async (customerId: string) => {
      const finderProfile =
        await FinderProfile.ofCustomer(customerId).findDetailed();
      return finderProfile !== undefined && finderProfile.hasAccess();
    },
  );

  public static customerIdHasAccessRequest = provideReact(
    async (customerId: string) => {
      return await FinderProfileRequest.find(customerId);
    },
  );

  public static getCustomersWithoutAccessOrAccessRequest = provideReact(
    async () => {
      const customers = await Customer.query().execute();
      const [finderProfiles, finderProfileRequests] = await Promise.all([
        FinderProfile.query().execute(),
        FinderProfileRequest.query().execute(),
      ]);

      return customers.items.filter(
        (customer) =>
          !finderProfiles.items.some(
            (finderProfile) => finderProfile.data.customerId === customer.id,
          ) &&
          !finderProfileRequests.items.some(
            (finderProfileRequest) =>
              finderProfileRequest.customerId === customer.id,
          ),
      );
    },
  );
}
